import { render } from "./event_archive_favorite_button.vue?vue&type=template&id=22dec12a"
import script from "./event_archive_favorite_button.vue?vue&type=script&lang=js"
export * from "./event_archive_favorite_button.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__